import React from 'react';
import { Grid } from '@mui/material';
import {
    BreadCrumbs,
    PageTitleWithToolTip
} from '../Common';
import MenuButton from '../MenuButton';
import UserInfo from '../../UserInfo';
import useNavigate from '../../hooks/useNavigate';
import useBreadCrumbs from '../../hooks/useBreadCrumbs';

const GeekCommandCenter = ({}) => {
    const navigate = useNavigate({
        pageName:'GeekCommandCenter'
    });
    useBreadCrumbs({
        path: { id: 'GeekCommandCenter', text: 'Geek Command Center', link: window.location.pathname, reset: true }
    });

    const menus = [
        {
            title: "Manage Service Providers",
            icon: "/images/ic_wrench_2.png",
            isVisible: UserInfo.isSystemAdministrator(),
            onClick: () => navigate.push(`/ManageServiceProviders`),
            imageStyle:{ width: 36, height: 36, margin: "0% auto" },
        },
        {
            title: "Manage location registration types",
            icon: "/images/ic_registration_type.png",
            isVisible: UserInfo.isSystemAdministrator(),
            onClick: () => navigate.push(`/ManageRegistration`),
            imageStyle:{ width: 62, height: 30, margin: "0% auto" },
        },
        {
            title: "Configure SSO",
            icon: "/images/instanceSSO.png",
            isVisible: UserInfo.isSystemAdministrator(),
            onClick: () => navigate.push(`/ConfigureSSO`),
            imageStyle:{ width: 38, height: 42, margin: "0% auto" },
        },
        {
            title: "Manage material types",
            icon: "/images/ic_material_type.png",
            isVisible: UserInfo.isSystemAdministrator(),
            onClick: () => navigate.push(`/ManageMaterialTypes`)
        },
        {
            title: "Manage Accounts",
            icon: "/images/cogwheel.png",
            isVisible: UserInfo.isSystemAdministrator(),
            onClick: () => navigate.push(`/ManageAccounts`),
        },
        {
            title: "Manage All Users",
            icon: "/images/ic_users_2.png",
            isVisible: UserInfo.isSystemAdministrator(),
            onClick: () => navigate.push(`/ManageAllUsers`),
        },
        {
            title: "Site Usage",
            icon: "/images/cogwheel.png",
            isVisible: UserInfo.isSystemAdministrator(),
            onClick: () => navigate.push(`/SiteUsage`),
        },
        {
            title: "Manufacturers",
            icon: "/images/ic_manufacturer.svg",
            isVisible: UserInfo.isSystemAdministrator(),
            onClick: () => navigate.push(`/Manufacturers`),
        },
        {
            title: "Manage business rules",
            icon: "/images/ic_workflow.svg",
            isVisible: UserInfo.isSystemAdministrator(),
            onClick: () => navigate.push(`/ManageBusinessRules`),
            imageStyle: { width: 36, height: 36, margin: "0% auto" },
        },
    ];

    return (
        <>
            <BreadCrumbs
                path={[
                    { text: 'Home', onClick: null },
                    { text: 'Geek Command Center', onClick: null }
                ]}
            />
            <Grid
                container
                spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}
            >
                <Grid item xs={12}>
                    <PageTitleWithToolTip
                        pageTitle="Geek Command Center"
                    />
                </Grid>
                <Grid item xs={12}>
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: "wrap",
                        gap: "20px"
                    }}>
                        {menus.filter(x => x.isVisible).map(option => (
                            <MenuButton
                                key={option.title}
                                imageStyle={option.imageStyle}
                                title={option.title}
                                icon={option.icon}
                                onClick={option.onClick}
                            />
                        ))}
                    </div>
                </Grid>
            </Grid>
        </>
    );

}

export default GeekCommandCenter;
